import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_NEW_UPDATES_REQUEST,
  fetchNewUpdatesSuccess,
  fetchNewUpdatesFailure,
} from "../actions/newUpdatesActions";
import { fetchNewUpdatesApi } from "../../../services/accIqService";

// function* fetchNewUpdatesSaga(action) {
//   try {
//     const response = yield call(fetchNewUpdatesApi, action.payload);

//     // adjust based on your API response structure
//     const data = response?.data?.result || {};

//     yield put(fetchNewUpdatesSuccess(data));
//   } catch (error) {
//     yield put(
//       fetchNewUpdatesFailure(error?.response?.data?.message || error.message)
//     );
//   }
// }

function* fetchNewUpdatesSaga(action) {
  try {
    const response = yield call(fetchNewUpdatesApi, action.payload);

    const rawData = response?.data?.subdimension_status;

    const transformedData = {
      added: rawData.added || [],
      removed: rawData.removed || [],
      update_in_progress: rawData.in_progress || [],
      update_completed: rawData.completed || [],
    };

    yield put(fetchNewUpdatesSuccess(transformedData));
  } catch (error) {
    yield put(
      fetchNewUpdatesFailure(error?.response?.data?.message || error.message)
    );
  }
}

export function* watchNewUpdatesSaga() {
  yield takeLatest(FETCH_NEW_UPDATES_REQUEST, fetchNewUpdatesSaga);
}
